import type { IsoWeekday } from '@zag/calendar/models';

export type { IsoWeekday };

export interface EmploymentRow {
  id: string;
  startDate: string;
  endDate: string | null;
  rrule: string | null;
  workdayMask: number;
  workloadHoursPerDay: number | null;
  workloadPercent: number | null;
}

export interface EmploymentDefaultShift {
  id?: string;
  shiftUnitId: string;
  validFrom: string | null;
  validTo: string | null;
  rrule: string | null;
}

export interface EmploymentWeekdayPlanning {
  defaultShifts: EmploymentDefaultShift[];
}

export interface EmploymentWeekdayDetails {
  weekday: IsoWeekday;
  planning?: EmploymentWeekdayPlanning;
}

export interface EmploymentDetails {
  weekdays: EmploymentWeekdayDetails[];
}

export type EmploymentCadenceUnit = 'day' | 'week' | 'month' | 'quarter' | 'year';

export interface EmploymentCadence {
  unit: EmploymentCadenceUnit;
  interval: number;
}

export type EmploymentRecurrence = { kind: 'simple'; cadence: EmploymentCadence } | { kind: 'custom'; rrule: string };

export interface EmploymentCollision {
  periodIds: readonly [string, string];
  firstDate: string;
  weekdays: IsoWeekday[];
}

export const NEW_EMPLOYMENT_ROW_KEY_PREFIX = 'new:';

export const EMPLOYMENT_ERROR_CODES = {
  collision: 'EMPLOYMENT_PERIOD_COLLISION',
  lastPeriod: 'EMPLOYMENT_LAST_PERIOD',
  defaultShiftInvalid: 'EMPLOYMENT_DEFAULT_SHIFT_INVALID',
  defaultShiftOverlap: 'EMPLOYMENT_DEFAULT_SHIFT_OVERLAP',
} as const;
